import Injection = EECore.Injection;
import Model from "../models/documentCentre/documentComponentModel";
import { WidgetResources } from "../../resources/widget";

@Injection.injectableClass("DocumentSearch")
export default class DocumentSearch implements EECore.UI.IWebComponent {

  @Injection.injectableProperty("DocumentSearch", EECore.Registrations.TEMPLATE_FACTORY)
  private templateFactory: EECore.UI.TemplateFactory;

  @Injection.injectableProperty("DocumentSearch", "WidgetResources")
  private resources: WidgetResources;

  constructor(templateFactory: EECore.UI.TemplateFactory, resources: WidgetResources) {
    this.templateFactory = templateFactory;
    this.resources = resources;
  }

  load(container: Element): Element {
    const title = container.getAttribute("ee-title");
    return this.renderTemplate(title);
  }

  private renderTemplate(title?: string): Element {
    const model = new Model();
    model.title = title ? title : this.resources.documentCentre.components.searchBarTitle;
    return this.templateFactory.getTemplate("DocumentSearch", model);
  }
}